import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { navigateToRecentSite } from "../drawer/mainCustomDrawerSlice";
import { resetUserState } from "../login/userSlice";

export type RecentSearchType = {
  clientName: string;
  siteName: string;
  siteId: string;
  clientId: string;
  siteNavigationOnly?: boolean;
};

export type HomePageStateType = {
  recentSearches: RecentSearchType[];
};

const initialState: HomePageStateType = {
  recentSearches: []
};

const homepageSlice = createSlice({
  name: "homePage",
  initialState: initialState,
  reducers: {
    saveRecentSearches(state, action: PayloadAction<RecentSearchType>) {
      const selectedSiteData = action.payload;
      if (state.recentSearches.length === 5) {
        state.recentSearches.pop();
      }
      state.recentSearches.unshift(selectedSiteData);
    }
  },

  extraReducers: (builder) => {
    builder.addCase(navigateToRecentSite, (state, action) => {
      const selectedSiteData = action.payload;
      if (selectedSiteData?.siteNavigationOnly) return;

      if (state.recentSearches.length === 5) {
        state.recentSearches.pop();
      }
      state.recentSearches.unshift(selectedSiteData);
    });
    builder.addCase(resetUserState.type, (state) => {
      state.recentSearches = [];
    });
  }
});

export const { saveRecentSearches } = homepageSlice.actions;
export default homepageSlice.reducer;
